import { Routes } from '@angular/router';
import { ROUTER_PATHS } from '@shared/constants/router-paths.constants';
import { authGuard } from '@shared/guards/auth.guard';

export const APP_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () => import('@features/dashboard/pages/dashboard/dashboard.component').then(c => c.DashboardComponent),
        canActivate: [authGuard]
    },
    {
        path: ROUTER_PATHS.AUTH.BASE,
        loadChildren: () => import('@features/auth/auth-page.routes').then(r => r.AUTH_ROUTES)
    },
    {
        path: ROUTER_PATHS.SURVEY,
        loadChildren: () => import('@features/survey/survey.routes').then(r => r.SURVEY_ROUTES)
    },
    {
        path: ROUTER_PATHS.DASHBOARD,
        loadComponent: () => import('@features/dashboard/pages/dashboard/dashboard.component').then(c => c.DashboardComponent),
        canActivate: [authGuard]
    },
    {
        path: ROUTER_PATHS.PROFILE.BASE,
        loadChildren: () => import('@features/profile/profile.routes').then(r => r.PROFILE_ROUTES),
        canActivate: [authGuard]
    },
    {
        path: ROUTER_PATHS.SERVICE.BASE,
        loadChildren: () => import('@features/service/service.routes').then(r => r.SERVICE_ROUTES),
        canActivate: [authGuard]
    },
    {
        path: ROUTER_PATHS.DELIVERY.BASE,
        loadChildren: () => import('@features/delivery/delivery.routes').then(r => r.DELIVERY_ROUTES),
        canActivate: [authGuard]
    },
    {
        path: ROUTER_PATHS.OPEN_ACCOUNT.BASE,
        loadChildren: () => import('@features/open-account/open-account.routes').then(r => r.OPEN_ACCOUNT_ROUTES),
        canActivate: []
    },
    {
        path: ROUTER_PATHS.INVOICE.BASE,
        loadChildren: () => import('@features/invoice/invoice.routes').then(r => r.INVOICE_ROUTES),
        canActivate: [authGuard]
    },
    {
        path: ROUTER_PATHS.TANK.BASE,
        loadChildren: () => import('@features/tank/tank.routes').then(r => r.TANK_ROUTES),
        canActivate: [authGuard]
    },
    {
        path: ROUTER_PATHS.BILLING.BASE,
        loadChildren: () => import('@features/billing-payment/billing-payments.routes').then(r => r.BILLING_ROUTES),
        canActivate: [authGuard]
    },
    {
        path: ROUTER_PATHS.INVALID_INVITE,
        loadComponent: () => import('@features/error/invalid-invite/invalid-invite.component').then(c => c.InvalidInviteComponent)
    }
];
